import { Injectable, signal } from "@angular/core";
import { Product } from "../../../interfaces/detail-order.interface";

@Injectable({
  providedIn: 'root'
})
export class ListProductsOrderService {
  private listProducts = signal<Product[]>([]);
  private isLoading = signal<boolean>(true);
  
  constructor() {}

  setListProducts(listProducts: Product[]) {
    this.listProducts.set(listProducts);
    this.isLoading.set(false);
  }

  getListProducts() {
    return this.listProducts();
  }
  
  getListProductsSignal() {
    return this.listProducts;
  }
  
  getLoadingState() {
    return this.isLoading;
  }
  
  setLoading(loading: boolean) {
    this.isLoading.set(loading);
  }
}
